import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Read config from environment (Create React App uses REACT_APP_*)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    ? { measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID }
    : {}),
}

const app = initializeApp(firebaseConfig)

// Analytics is optional and only works in browsers
let analytics
try {
  if (firebaseConfig.measurementId && typeof window !== 'undefined') {
    analytics = getAnalytics(app)
  }
} catch {
  // ignore analytics initialization errors in unsupported environments
}

export { analytics }
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)